// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.book-simulator-container {
    position: relative;
    width: 100%;
    height: 100%;
}

div.gesture-swipe-outer-container {
    position: absolute;
    width: fit-content;
    right: 0px;
    top: 0px;
}

div.reset-sim-container {
    position: absolute;
    width: fit-content;
    right: 5%;
    top: 6%;
}

button.reset-sim{
    border-color:var(--color-component-border);
}
`, "",{"version":3,"sources":["webpack://./src/Controls/Simulators/css/BookSimulator.css"],"names":[],"mappings":"AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,OAAO;AACX;;AAEA;IACI,0CAA0C;AAC9C","sourcesContent":["@import '../../../css/App.css';\r\n\r\ndiv.book-simulator-container {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\ndiv.gesture-swipe-outer-container {\r\n    position: absolute;\r\n    width: fit-content;\r\n    right: 0px;\r\n    top: 0px;\r\n}\r\n\r\ndiv.reset-sim-container {\r\n    position: absolute;\r\n    width: fit-content;\r\n    right: 5%;\r\n    top: 6%;\r\n}\r\n\r\nbutton.reset-sim{\r\n    border-color:var(--color-component-border);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
